export default __webpack_public_path__ + "static/media/david-broza_mitachat-lashamaim.6fe648a4.mp3";